import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useQueryClient } from '@tanstack/react-query'
import { Button, showToast } from '@mercai/clever'
import { QUERIES_ADMIN, useBulkQuotationRequest } from '@/services'

import { TableQuotationRequest } from '@/pages/business/quotation-request-v2/list/components'

import { ModalBulkKam } from '../modal-bulk-kam'

import { QuotationRequestProps } from './quotation-request.type'

export const QuotationRequest = ({
  buyerProfileUuid,
  isLoadingKams = false,
  kams = [],
  setSearchKams,
}: QuotationRequestProps) => {
  const { t } = useTranslation('screenProfileShow')

  const queryClient = useQueryClient()

  const [isOpenModalBulkKam, setisOpenModalBulkKam] = useState(false)

  const [rfqChecked, setRfqChecked] = useState<string[]>([])

  const [selectedKam, setSelectedKam] = useState<{
    label: string
    value: string
  }>()

  const kamsOptions = useMemo(() => {
    const kamsWithName = kams?.filter((user) => user?.name) || []

    const mappedKams = kamsWithName.map((user) => ({
      label: user.name,
      value: `${user.id}`,
    }))

    const options = [...mappedKams]

    return options.sort((a, b) => a.label.localeCompare(b.label))
  }, [kams])

  const { mutateAsync: bulkQuotationRequestKam, isPending: isLoadingBulk } =
    useBulkQuotationRequest()

  const onBulkRfqKAM = async () => {
    const response = await bulkQuotationRequestKam({
      data: {
        keyAccountManagerId: selectedKam?.value
          ? +selectedKam?.value
          : undefined,
      } as Partial<QuotationRequestProps>,
      items: rfqChecked,
    })

    if (!response.success) {
      showToast({
        variant: 'error',
        title: t('bulkKAMError'),
      })
      return
    }

    setRfqChecked([])
    setisOpenModalBulkKam(false)
    setSelectedKam(undefined)

    showToast({
      variant: 'success',
      title: t('bulkKAMSuccess'),
    })

    queryClient.invalidateQueries({
      queryKey: [QUERIES_ADMIN.QUOTATION_REQUEST.module],
    })
  }

  const BulkRfqKAM = () => {
    return (
      <Button
        variant="primary"
        onClick={() => setisOpenModalBulkKam(true)}
        disabled={rfqChecked.length === 0}
      >
        {t('bulkKAMButton')}
      </Button>
    )
  }

  const onCloseModalBulkKam = () => {
    setisOpenModalBulkKam(false)
    setSelectedKam(undefined)
  }

  return (
    <>
      <TableQuotationRequest
        buyerProfile={buyerProfileUuid}
        hasAddButton
        setCheckedRows={setRfqChecked}
        checkedRows={rfqChecked}
        {...(rfqChecked.length > 0 && { headerComponents: <BulkRfqKAM /> })}
      />

      {isOpenModalBulkKam && (
        <ModalBulkKam
          onClose={onCloseModalBulkKam}
          isOpen={isOpenModalBulkKam}
          kams={kamsOptions}
          isLoadingKams={isLoadingKams}
          setSearchKams={setSearchKams}
          selectedKam={selectedKam}
          setSelectedKam={setSelectedKam}
          onSubmit={onBulkRfqKAM}
          isLoadingSubmit={isLoadingBulk}
        />
      )}
    </>
  )
}
